import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Termos() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto space-y-6">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" /> Voltar
        </Button>

        <Card>
            <CardHeader>
                <CardTitle className="text-2xl text-indigo-900">Termos de Uso e Política de Privacidade</CardTitle>
            </CardHeader>
            <CardContent className="prose max-w-none text-gray-700 space-y-6">
                <p className="text-sm text-gray-500">Última atualização: {new Date().toLocaleDateString()}</p>
                
                {/* --- SEÇÃO 1: COOKIES --- */}
                <section>
                  <h2 className="text-xl font-bold text-gray-900 mb-4">1. Política de Cookies</h2>
                  <p>
                    A <strong>Operya</strong> utiliza Cookies de navegador, scripts e tecnologias similares para fornecer, proteger e melhorar a experiência em nossa plataforma. Abaixo, explicamos como nossos Cookies funcionam.
                  </p>

                  <h3 className="text-lg font-semibold text-gray-900 mt-4">O que são Cookies?</h3>
                  <p>
                    Os Cookies são pequenos arquivos de texto armazenados no seu computador ou dispositivo móvel quando você visita nosso site ou acessa nosso sistema. Eles servem para memorizar suas preferências (como login, idioma, etc.) e entender como os usuários interagem com a plataforma.
                  </p>

                  <h3 className="text-lg font-semibold text-gray-900 mt-4">Quais Cookies usamos?</h3>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>
                      <strong>Cookies Essenciais:</strong> Fundamentais para o funcionamento do sistema Operya (login seguro, sessão do usuário, etc.).
                    </li>
                    <li>
                      <strong>Cookies de Análise:</strong> Permitem medir o desempenho do nosso sistema e fontes de tráfego.
                    </li>
                    <li>
                      <strong>Cookies Funcionais:</strong> Permitem funcionalidades aprimoradas e personalização.
                    </li>
                  </ul>
                </section>

                <div className="border-t border-gray-200 my-8"></div>

                {/* --- SEÇÃO 2: TERMOS DE USO --- */}
                <section>
                  <h2 className="text-xl font-bold text-gray-900 mb-4">2. Termos e Condições de Uso</h2>
                  <p>
                    O presente instrumento regula a utilização por você ("Usuário") dos serviços oferecidos pelo sistema <strong>Operya</strong> ("Plataforma").
                  </p>

                  <div className="space-y-4 mt-4">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.1. Aceitação dos Termos</h3>
                      <p>
                        Ao acessar a Plataforma, o Usuário declara ter lido, compreendido e aceito estes Termos e Condições. A aceitação destes termos é condição indispensável para a prestação dos serviços.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.2. Objeto e Funcionalidade</h3>
                      <p>
                        O <strong>Operya</strong> é uma plataforma SaaS (Software as a Service) desenvolvida para gestão de agências de viagens e turismo. O uso da Plataforma é restrito a assinantes ativos e seus colaboradores autorizados.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.3. Cadastro e Segurança</h3>
                      <ul className="list-disc pl-5 mt-2">
                        <li>O Usuário compromete-se a fornecer dados verdadeiros e atuais.</li>
                        <li>O login e senha são pessoais e intransferíveis.</li>
                        <li>O Usuário é o único responsável pela guarda e sigilo de suas credenciais.</li>
                      </ul>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.4. Pagamentos e Assinaturas</h3>
                      <p>
                        O acesso ao sistema é concedido mediante o pagamento de assinatura conforme plano escolhido. O não pagamento poderá resultar na suspensão temporária ou cancelamento definitivo do acesso.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.5. Privacidade e Proteção de Dados (LGPD)</h3>
                      <p>
                        Coletamos dados mínimos para o funcionamento do sistema. A Operya atua em conformidade com a LGPD, garantindo medidas de segurança para proteger os dados inseridos na Plataforma. Seus dados não são vendidos a terceiros. A Operya adota práticas de segurança da informação alinhadas aos padrões de mercado, incluindo criptografia na transmissão de dados (SSL/HTTPS), backups diários e controle de acesso restrito aos servidores.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.6. Responsabilidades</h3>
                      <p>
                        A Operya empenha-se para manter o sistema disponível 24/7, contudo, não garante que o serviço será ininterrupto ou livre de erros. A Operya não se responsabiliza por decisões comerciais tomadas pelo Usuário com base nos relatórios do sistema.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.7. Cancelamento</h3>
                      <p>
                        Você pode solicitar o cancelamento de sua assinatura a qualquer momento através dos canais de suporte ou painel de controle, conforme as regras do seu contrato específico.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.8. Propriedade e Exportação dos Dados Os dados inseridos na Plataforma são de propriedade exclusiva do Usuário.</h3>
                      <p>
                        A Operya atua apenas como operadora do tratamento desses dados. O Usuário poderá, a qualquer momento durante a vigência da assinatura, exportar seus dados (clientes, vendas, financeiro) em formato padrão de mercado (ex: .csv ou .xlsx) através das ferramentas disponíveis no sistema. Em caso de cancelamento, o Usuário terá um prazo de 30 (trinta) dias para solicitar a exportação de seus dados antes que sejam excluídos permanentemente de nossos servidores.
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-bold text-gray-900">2.9. Exclusão de dados.</h3>
                      <p>
                        Após o encerramento do contrato e decorrido o prazo de retenção legal ou solicitação de exportação, a Operya compromete-se a eliminar de forma segura os dados do Usuário, ressalvadas as hipóteses de guarda obrigatória previstas em lei.
                      </p>
                    </div>

                  </div>
                </section>

                <div className="border-t border-gray-200 my-8"></div>

                <section className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                  <h3 className="text-md font-bold text-blue-900">Fale Conosco</h3>
                  <p className="text-sm text-blue-800 mt-2">
                    Em caso de dúvidas sobre estes termos ou sobre o tratamento de seus dados, entre em contato através do e-mail: <strong>suporte@operya.com.br</strong>
                  </p>
                </section>

            </CardContent>
        </Card>
      </div>
    </div>
  );
}